module.exports = __webpack_public_path__ + "img/mession-2.db61707c.png";